import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom';
import firebase from 'firebase/app';
import 'firebase/auth'
import 'firebase/firestore'
import { useDispatch, useSelector } from 'react-redux'

import Loading from '../Loading/Loading';
import {
    getMapSize,
    getPackProgress,
} from '../../util/util'
import Home from './Home/Home';
import Lesson from './Lesson/Lesson';
import Stage from './Stage/Stage';
import { saveScores, saveWords, saveSentences } from '../../store/actions';
import Review from './Review/Review';


const HOME = 'HOME'
const LESSON = 'LESSON'
const STAGE = 'STAGE'
const REVIEW = 'REVIEW'

const Course = () => {

    let history = useHistory();

    const [loaded, setLoaded] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);
    const [packages, setPackages] = useState(null)

    const [displayName, setDisplayName] = useState('Anonymous')
    const [userType, setUserType] = useState('Basic')

    const [packsProgress, setPacksProgress] = useState([])
    const [maxPacksProgress, setMaxPacksProgress] = useState([])
    const [page, setPage] = useState(HOME)
    const [lesson, setLesson] = useState()

    const scores = useSelector(state => state.scores)
    const words = useSelector(state => state.words)

    const dispatch = useDispatch();

    const loginStateListener = () => {
        firebase.auth().onAuthStateChanged(function (user) {
            if (user) {
                // User is signed in.
                //var isAnonymous = user.isAnonymous;
                //var uid = user.uid;
                if (user.displayName) setDisplayName(user.displayName)
                else if (!user.isAnonymous) {
                    setDisplayName(user.email.split('@')[0])
                }

                const dbh = firebase.firestore()
                dbh.collection('lessons').doc('lessons')
                    .get()
                    .then((doc) => {
                        if (doc.exists) {
                            const d = doc.data()
                            const packs = d.packages.slice(0, Number(d.package_count));
                            setPackages(packs)

                            dbh.collection('users').doc(user.uid)
                                .get()
                                .then((doc) => {
                                    if (doc.exists) {
                                        const d = doc.data()
                                        if (d.userType) setUserType(d.userType)
                                        if (d.scores) dispatch(saveScores(d.scores))
                                        if (d.words) dispatch(saveWords(d.words))
                                        if (d.sentences) dispatch(saveSentences(d.sentences))
                                        setLoaded(true)
                                    }
                                    else {
                                        setLoaded(true)
                                    }
                                })
                        }
                        else {
                            // Error
                        }
                    })


            } else {
                history.replace('/login')
            }
            // ...
        });
    }

    useEffect(loginStateListener, [])

    useEffect(() => {
        if (packages && (scores && getMapSize(scores) > 0)) {
            let count = 0
            let updatedPackagesProgress = []
            let updatedMaxPackagesProgress = []

            for (let i = 0; i < packages.length; i++) {
                [updatedPackagesProgress[count], updatedMaxPackagesProgress[count]] = getPackProgress(packages[i], scores)
                count += 1
            }

            setPacksProgress(updatedPackagesProgress)
            setMaxPacksProgress(updatedMaxPackagesProgress)
        }

    }, [packages, scores])

    useEffect(() => {
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, [])

    const handleResize = () => {
        setWidth(window.innerWidth)
    }

    const historyChangeListener = () => {
        history.listen(({ state }) => {
            //console.log(history);
            console.log(state);
            if (state && state.page) {
                switch (state.page) {
                    case HOME:
                        setPage(HOME)
                        break
                    case LESSON:
                        setPage(LESSON)
                        setLesson(state.lesson)

                        break
                    case STAGE:
                        setPage(STAGE)
                        break

                    case REVIEW:
                        setPage(REVIEW)
                        break

                    default:
                        setPage(HOME)
                }
            }
            else {
                setPage(HOME)
            }
        })
    }

    useEffect(historyChangeListener, [])

    const handleLogout = () => {
        firebase.auth().signOut().then(() => {
            history.replace('/login')
        })
    }



    if (!loaded) {
        return <Loading />
    }
        

    let content = null
    switch (page) {
        case HOME:
            content = <Home
                userType={userType}
                displayName={displayName}
                width={width}
                onLogoutClick={() => handleLogout()}
                packages={packages}
                packsProgress={packsProgress}
                scores={scores}
                words={words}
                maxPacksProgress={maxPacksProgress} />
            break;
        case LESSON:
            content = <Lesson
                lesson={lesson}
                scores={scores[lesson.id]} />
            break
        case STAGE:
            content = <Stage />
            break;
        case REVIEW:
            content = <Review />
            break
        default:
            content = null
    }

    return (
        <>
            {content}
        </>

    )
}



export default Course
